import type { Container } from 'inversify';
import { createContext, useContext, useEffect, useRef, useState } from 'react';

export const iocContext = createContext<Container | null>(null);

export function useInject<T>(name: symbol): T {
  const container = useContext(iocContext);

  if (!container) {
    throw new Error('You have forgotten to wrap app to iocContext.Provider');
  }

  return container.get<T>(name);
}

export function useDynamicInject<T>(name: symbol): [T | undefined, boolean, Error?] {
  const container = useContext(iocContext);
  const [hasBeenLoaded, setHasBeenLoaded] = useState(false);
  const [error, setError] = useState<Error>();
  const ref = useRef<T>();

  // без useEffect, setError вызывает ререндер и повторный вызов хука
  // из-за чего попытки инжекта при реджектах были бесконечными
  // хотя в использующие хук провайдеры зашивается ограничение на количество попыток
  useEffect(() => {
    if (!container) {
      throw new Error('You have forgotten to wrap app to iocContext.Provider');
    }

    container
      .get<Promise<T>>(name)
      .then(module => {
        ref.current = module;
        setHasBeenLoaded(true);
      })
      .catch(err => {
        setError(err);
      });
  }, []);

  return [ref.current, hasBeenLoaded, error];
}
